import React, { useState, useEffect, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Card, CardBody, Button, Row, Col } from "reactstrap";
import { Fn_AddEditData, Fn_FillListData } from "../../store/Functions";
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";
import { useLocation, useNavigate } from "react-router-dom";
import { Save, ArrowLeft, Info } from "react-feather";

const AddEdit_VehicleTypeInstructionMaster = () => {
  const API_URL_SAVE = "VehicleTypeInstructionMaster/0/token";
  const API_URL_BY_VEHICLE = API_WEB_URLS.MASTER + "/0/token/VehicleTypeInstructionByVehicleType/Id";
  const API_URL_VEHICLE_TYPE = API_WEB_URLS.MASTER + "/0/token/VehicleType/Id/0";

  const [state, setState] = useState({
    id: 0,
    formData: {
      F_VehicleType: "",
      Line1: "",
      Line2: "",
      Line3: "",
      Line4: "",
      Line5: "",
      Line6: "",
      Line7: "",
      Line8: "",
      Line9: "",
      Line10: "",
      IsActive: true,
    },
  });

  const [vehicleTypeList, setVehicleTypeList] = useState([]);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const vehicleTypeRef = useRef(null);

  useEffect(() => {
    Fn_FillListData(dispatch, setVehicleTypeList, "gridData", API_URL_VEHICLE_TYPE);

    const vehicleTypeId =
      (location.state && (location.state.F_VehicleType || location.state.Id)) || 0;

    if (vehicleTypeId > 0) {
      fetchDataByVehicleType(vehicleTypeId);
    }
  }, [dispatch, location.state]);

  const fetchDataByVehicleType = (vehicleTypeId) => {
    if (!vehicleTypeId) {
      setState({
        id: 0,
        formData: {
          F_VehicleType: "",
          Line1: "",
          Line2: "",
          Line3: "",
          Line4: "",
          Line5: "",
          Line6: "",
          Line7: "",
          Line8: "",
          Line9: "",
          Line10: "",
          IsActive: true,
        },
      });
      return;
    }

    setLoading(true);
    Fn_FillListData(
      dispatch,
      (dataList) => {
        setLoading(false);
        if (!dataList || dataList.length === 0) {
          setState({
            id: 0,
            formData: {
              F_VehicleType: String(vehicleTypeId),
              Line1: "",
              Line2: "",
              Line3: "",
              Line4: "",
              Line5: "",
              Line6: "",
              Line7: "",
              Line8: "",
              Line9: "",
              Line10: "",
              IsActive: true,
            },
          });
          return;
        }

        const rec = dataList[0];
        setState({
          id: rec.Id || 0,
          formData: {
            F_VehicleType: String(rec.F_VehicleType || vehicleTypeId),
            Line1: rec.Line1 ? rec.Line1 : "",
            Line2: rec.Line2 ? rec.Line2 : "",
            Line3: rec.Line3 ? rec.Line3 : "",
            Line4: rec.Line4 ? rec.Line4 : "",
            Line5: rec.Line5 ? rec.Line5 : "",
            Line6: rec.Line6 ? rec.Line6 : "",
            Line7: rec.Line7 ? rec.Line7 : "",
            Line8: rec.Line8 ? rec.Line8 : "",
            Line9: rec.Line9 ? rec.Line9 : "",
            Line10: rec.Line10 ? rec.Line10 : "",
            IsActive: rec.IsActive !== undefined && rec.IsActive !== null ? rec.IsActive : true,
          },
        });
      },
      "gridData",
      API_URL_BY_VEHICLE + "/" + vehicleTypeId
    );
  };

  const validationSchema = Yup.object().shape({
    F_VehicleType: Yup.string().required("Vehicle Type is required"),
  });

  const handleSubmit = (values, { setSubmitting }) => {
    const formData = new FormData();
    formData.append("Id", state.id || 0);
    formData.append("F_VehicleType", values.F_VehicleType);
    formData.append("Line1", values.Line1 || "");
    formData.append("Line2", values.Line2 || "");
    formData.append("Line3", values.Line3 || "");
    formData.append("Line4", values.Line4 || "");
    formData.append("Line5", values.Line5 || "");
    formData.append("Line6", values.Line6 || "");
    formData.append("Line7", values.Line7 || "");
    formData.append("Line8", values.Line8 || "");
    formData.append("Line9", values.Line9 || "");
    formData.append("Line10", values.Line10 || "");
    formData.append("IsActive", values.IsActive ? "true" : "false");

    let currentUserId = 0;
    try {
      const rawUser = localStorage.getItem("user");
      const rawAuth = localStorage.getItem("authUser");
      let userObj = null;
      if (rawUser && rawUser !== "undefined" && rawUser !== "null") {
        userObj = JSON.parse(rawUser);
      } else if (rawAuth && rawAuth !== "undefined" && rawAuth !== "null") {
        userObj = JSON.parse(rawAuth);
      }
      if (userObj) {
        currentUserId = userObj.uid || userObj.Id || userObj.id || userObj.userId || 0;
      }
    } catch (parseErr) {
      console.warn("Could not parse user from localStorage:", parseErr);
    }
    formData.append("UserId", currentUserId);

    Fn_AddEditData(
      dispatch,
      setState,
      { arguList: { id: state.id, formData: formData } },
      API_URL_SAVE,
      true,
      "instructionid",
      navigate,
      "/VehicleTypeInstructionMaster"
    ).finally(function () {
      setSubmitting(false);
    });
  };

  return (
    <div style={{ padding: "8px 12px", maxWidth: 1000, margin: "0 auto" }}>
      {/* Top action bar */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 10,
          paddingBottom: 6,
          borderBottom: "1px solid #dee2e6",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <Button
            size="sm"
            variant="outline-secondary"
            className="py-1 px-2"
            onClick={() => navigate("/VehicleTypeInstructionMaster")}
            style={{ fontSize: 12 }}
          >
            <ArrowLeft size={14} style={{ marginRight: 4 }} /> Back
          </Button>
          <span style={{ fontSize: 16, fontWeight: 700, color: "#333" }}>
            {state.id > 0 ? "Edit Vehicle Instructions" : "Add Vehicle Instructions"}
          </span>
        </div>
      </div>

      {/* Info notice */}
      <div
        style={{
          backgroundColor: "#fff8f2",
          border: "1px solid #fed7aa",
          borderRadius: 6,
          padding: "8px 12px",
          marginBottom: 12,
          display: "flex",
          alignItems: "flex-start",
          gap: 8,
          fontSize: 12,
          color: "#9a3412",
        }}
      >
        <Info size={16} style={{ marginTop: 2, flexShrink: 0 }} />
        <div>
          <strong>Read before Booking Lines:</strong> Enter up to 10 bullet lines for this vehicle type.
          In the Customer App, only the lines you fill in will appear. Empty lines are automatically hidden.
        </div>
      </div>

      <Card style={{ border: "1px solid #e2e8f0", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
        <CardBody style={{ padding: 16 }}>
          <Formik
            enableReinitialize
            initialValues={state.formData}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ values, errors, touched, isSubmitting, setFieldValue }) => (
              <Form>
                {/* Vehicle Selection */}
                <Row className="mb-3">
                  <Col md={6}>
                    <label style={{ fontSize: 12, fontWeight: 600, color: "#333" }}>
                      Vehicle Type <span className="text-danger">*</span>
                    </label>
                    <Field
                      as="select"
                      name="F_VehicleType"
                      innerRef={vehicleTypeRef}
                      className={`form-select form-select-sm ${
                        touched.F_VehicleType && errors.F_VehicleType ? "is-invalid" : ""
                      }`}
                      style={{ fontSize: 12 }}
                      onChange={(e) => {
                        const vId = e.target.value;
                        setFieldValue("F_VehicleType", vId);
                        fetchDataByVehicleType(vId);
                      }}
                    >
                      <option value="">-- Select Vehicle Type --</option>
                      {vehicleTypeList.map((v) => (
                        <option key={v.Id} value={v.Id}>
                          {v.Name}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage
                      name="F_VehicleType"
                      component="div"
                      className="invalid-feedback"
                      style={{ fontSize: 11 }}
                    />
                  </Col>

                  <Col md={6} className="d-flex align-items-center mt-3 mt-md-0">
                    <div className="form-check form-switch mt-3">
                      <Field
                        type="checkbox"
                        id="IsActiveSwitch"
                        name="IsActive"
                        className="form-check-input"
                        checked={values.IsActive}
                        onChange={(e) => setFieldValue("IsActive", e.target.checked)}
                      />
                      <label
                        htmlFor="IsActiveSwitch"
                        className="form-check-label"
                        style={{ fontSize: 12, fontWeight: 600 }}
                      >
                        Status Active
                      </label>
                    </div>
                  </Col>
                </Row>

                <hr style={{ borderColor: "#eee", margin: "16px 0 12px 0" }} />

                <div style={{ marginBottom: 12 }}>
                  <span style={{ fontSize: 13, fontWeight: 700, color: "#1e293b" }}>
                    Instruction Lines (Line 1 to Line 10)
                  </span>
                  <span style={{ fontSize: 11, color: "#64748b", marginLeft: 8 }}>
                    (Fill only the lines you want displayed in the app)
                  </span>
                </div>

                {/* 10 Instruction Line Inputs */}
                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                  {[
                    { name: "Line1", num: 1, placeholder: "e.g. Fare includes 15 mins free loading/unloading time." },
                    { name: "Line2", num: 2, placeholder: "e.g. ₹ 1.5/min for additional loading/unloading time." },
                    { name: "Line3", num: 3, placeholder: "e.g. Fare may change if route or location changes." },
                    { name: "Line4", num: 4, placeholder: "e.g. Parking charges to be paid by customer." },
                    { name: "Line5", num: 5, placeholder: "e.g. Fare includes toll and permit charges, if any." },
                    { name: "Line6", num: 6, placeholder: "e.g. We don't allow overloading." },
                    { name: "Line7", num: 7, placeholder: "e.g. Driver will assist in loading up to ground floor." },
                    { name: "Line8", num: 8, placeholder: "e.g. Fragile items must be packed properly by customer." },
                    { name: "Line9", num: 9, placeholder: "e.g. Additional helper charges apply if requested." },
                    { name: "Line10", num: 10, placeholder: "e.g. Cancellation charges apply after 5 mins of booking." },
                  ].map((item) => (
                    <div
                      key={item.name}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        backgroundColor: values[item.name] ? "#faf5ff" : "#f8fafc",
                        padding: "6px 10px",
                        borderRadius: 6,
                        border: values[item.name] ? "1px solid #e9d5ff" : "1px solid #e2e8f0",
                      }}
                    >
                      <span
                        style={{
                          width: 60,
                          fontSize: 12,
                          fontWeight: 600,
                          color: values[item.name] ? "#7e22ce" : "#475569",
                        }}
                      >
                        Line {item.num}:
                      </span>
                      <Field
                        type="text"
                        name={item.name}
                        placeholder={item.placeholder}
                        className="form-control form-control-sm"
                        style={{ fontSize: 12, flex: 1, height: 32 }}
                      />
                      {values[item.name] && (
                        <Button
                          size="sm"
                          variant="link"
                          className="p-0 text-muted"
                          style={{ fontSize: 11, textDecoration: "none" }}
                          onClick={() => setFieldValue(item.name, "")}
                          title="Clear line"
                        >
                          ✕
                        </Button>
                      )}
                    </div>
                  ))}
                </div>

                {/* Submit Actions */}
                <div style={{ marginTop: 20, display: "flex", gap: 10 }}>
                  <Button
                    type="submit"
                    color="primary"
                    disabled={isSubmitting || loading}
                    style={{ fontSize: 13, padding: "6px 18px" }}
                  >
                    <Save size={14} style={{ marginRight: 6 }} />
                    {isSubmitting ? "Saving..." : "Save Instructions"}
                  </Button>
                  <Button
                    type="button"
                    color="secondary"
                    outline
                    onClick={() => navigate("/VehicleTypeInstructionMaster")}
                    style={{ fontSize: 13, padding: "6px 18px" }}
                  >
                    Cancel
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </CardBody>
      </Card>
    </div>
  );
};

export default AddEdit_VehicleTypeInstructionMaster;
